
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dietetics",
      function () {
        return require("private-next-pages/dietetics.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dietetics"])
      });
    }
  